
<n-modal-background
  v-if="open"
  :suppressed="suppressedForUnlock"
  :closeOnEscape="!suppressedForUnlock"
  :closeOnOutside="!suppressedForUnlock"
  @close="handleClose"
  ref="bg"
>
  <n-simple-modal-body :title="modalTitle" :titleSuffix="'[' + $t('general.beta') + ']'" @close="$refs.bg.close()">
    <div class="form-fields">
      <n-input :value="effectiveVariableName" :label="$t('variableModal.variableLabel')" disabled />
      <n-input
        :value="displayLabel"
        :label="$t('variableModal.displayLabelLabel')"
        :placeholder="$t('variableModal.displayLabelPlaceholder')"
        :maxlength="maxDisplayLabelLength"
        @input="onDisplayLabelInput"
      />
      <n-select
        :value="selectedType"
        :options="typeOptions"
        :label="$t('variableModal.typeLabel')"
        :error="typeError"
        :toLabel="toLabel"
        @select="onTypeSelect"
      />
      <n-select
        v-if="isDateLikeType"
        :value="selectedDateFormat"
        :options="dateFormatOptions"
        :label="dateFormatLabel"
        :error="dateFormatError"
        :toLabel="formatOptionLabel"
        @select="onDateFormatSelect"
      />
      <p v-if="isDateLikeType && dateFormatError" class="field-error">{{ dateFormatError }}</p>
      <div v-if="isDateLikeType && selectedType" class="date-picker-field">
        <label class="date-picker-label">{{ $t('variableModal.defaultValueLabel') }}</label>
        <date-picker
          v-model="defaultValue"
          :placeholder="datePlaceholder"
          :format="datePickerFormat"
          :type="datePickerType"
          prefix-class="variable-date"
          valueType="format"
          @input="onDefaultValueInput"
        />
        <p v-if="defaultValueError" class="field-error">{{ defaultValueError }}</p>
      </div>
      <div v-if="isDropdownType && selectedType" class="dropdown-options-field">
        <label class="dropdown-options-label">
          {{ $t('variableModal.dropdownOptionsLabel') || 'Dropdown Options' }}
        </label>
        <div
          ref="dropdownOptionsScrollContainer"
          class="dropdown-options-scroll-container"
          :class="{ 'show-scroll': shouldShowScroll }"
        >
          <div class="dropdown-options-list">
            <div v-for="(option, index) in dropdownOptions" :key="index" class="dropdown-option-row">
              <n-input
                :value="option"
                :placeholder="$t('variableModal.dropdownOptionPlaceholder') || 'Enter option value'"
                :error="optionErrors[index]"
                :maxlength="maxOptionLength"
                @input="onDropdownOptionInput(index, $event)"
                @keydown="onDropdownOptionKeyDown(index, $event)"
                @blur="onDropdownOptionBlur(index)"
                class="dropdown-option-input"
              />
              <div class="dropdown-option-actions">
                <n-icon icon="trash" size="s" class="delete-icon" @click="removeDropdownOption(index)" />
                <n-icon
                  v-if="index === dropdownOptions.length - 1 && dropdownOptions.length < maxDropdownOptions"
                  icon="plus"
                  size="s"
                  class="add-icon"
                  @click="addDropdownOption"
                />
              </div>
            </div>
          </div>
        </div>
        <p v-if="dropdownOptionsError" class="field-error">{{ dropdownOptionsError }}</p>
      </div>
      <n-select
        v-if="isDropdownType && selectedType"
        :value="defaultValue || undefined"
        :options="dropdownDefaultValueOptions"
        :label="$t('variableModal.defaultValueLabel')"
        :placeholder="$t('variableModal.defaultValueDropdownPlaceholder') || 'Select a default value'"
        :error="defaultValueError"
        :toLabel="toLabelDropdownDefault"
        @select="onDefaultValueSelect"
      />
      <n-input
        v-else-if="selectedType && !isDateLikeType && !isDropdownType"
        :value="defaultValue"
        :autofocus="!isEditMode"
        :label="$t('variableModal.defaultValueLabel')"
        :placeholder="$t('variableModal.defaultValuePlaceholder')"
        :error="defaultValueError"
        :type="getInputType"
        :maxlength="maxDefaultValueLength"
        @input="onDefaultValueInput"
        @keydown="onKeyDown"
        @blur="onDefaultValueBlur"
      />
    </div>
    <template #rightFooter>
      <n-button :label="submitButtonLabel" @click="handleSubmit" :disabled="!isValid || loading" :loading="loading" />
    </template>
  </n-simple-modal-body>
</n-modal-background>
